import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import SalesLayOut from "views/Sales-Sections/SalesLayOut";

const WarehouseTransfer = Loadable(
  lazy(() => import("views/others/WarehouseTransfer"))
);

const WarehouseTransferRoute = {
  path: "/",
  element: <SalesLayOut />,
  children: [
    {
      path: "others/warehouseTransfer",
      element: <WarehouseTransfer />,
      ref: "inventory-warehouse-transfer"
    }
  ]
};

export default WarehouseTransferRoute;
